import React from 'react';
import { useEntitlements } from '../../contexts/EntitlementContext';

/**
 * Renders the simplified experience for LaunchPoint Lite tenants (formerly Essentials),
 * otherwise the existing full-LaunchPoint element. Keeps full LaunchPoint completely
 * unchanged for every other tier.
 */
export const EssentialsOr: React.FC<{ essentials: React.ReactNode; full: React.ReactNode }> = ({
  essentials,
  full,
}) => {
  const { getTier } = useEntitlements();
  return <>{getTier() === 'LITE' ? essentials : full}</>;
};

export default EssentialsOr;
